import React from 'react';

// Make group for face '.fill--face'
// Make glasses target 'ref="glassesTarget"'
// Make groups for each eye group
// - '.fill-eyes eyes'
// - '.fill-face eyes--blink'
// - '.fill-face eyes--is-being-pet--likes'
// - '.fill-eyes eyes--is-being-pet--hates'

export default class Eyes extends React.Component {
	componentDidMount() {
		this.props.getGlassesTargetCoords(this.refs.glassesTarget);
	}
	render() {
		return (
			<g className="fill--face">
				<circle ref="glassesTarget" cx="214.2627563" cy="199.0496063" r="0" />
				<g className="fill--eyes eyes">
					<ellipse cx="184.2627563" cy="199.0496063" rx="7.6592607" ry="8.5102901" />
					<ellipse cx="244.2627563" cy="199.0496063" rx="7.6592607" ry="8.5102901" />
				</g>
				<g className="fill--face eyes--blink">
					<path d="M191.8984985,205.0343018c-0.1542969,0-0.3105469-0.0141602-0.4677734-0.0439453l-15.265625-2.8896484
						c-1.3564453-0.2568359-2.2480469-1.5649414-1.9912109-2.9213867c0.2568359-1.3569336,1.5634766-2.2470703,2.9208984-1.9916992
						l15.265625,2.8896484c1.3564453,0.2568359,2.2480469,1.5649414,1.9912109,2.9213867
						C194.125061,204.1983643,193.0762329,205.0343018,191.8984985,205.0343018z" />
					<path d="M236.6270142,205.0343018c0.1542969,0,0.3105469-0.0141602,0.4677734-0.0439453l15.265625-2.8896484
						c1.3564453-0.2568359,2.2480469-1.5649414,1.9912109-2.9213867c-0.2568359-1.3569336-1.5634766-2.2470703-2.9208984-1.9916992
						l-15.265625,2.8896484c-1.3564453,0.2568359-2.2480469,1.5649414-1.9912109,2.9213867
						C234.4004517,204.1983643,235.4492798,205.0343018,236.6270142,205.0343018z" />
				</g>
				<g className="fill--face eyes--is-being-pet--likes">
					<path d="M191.6562347,204.9013824c-0.6044922,0-1.2099609-0.2177734-1.6904297-0.6591797
						c-0.9189453-0.84375-2.9033203-1.7983398-5.7177734-1.9462891c-2.8125-0.1425781-4.8876953,0.5942383-5.8896484,1.3378906
						c-1.1103516,0.8237305-2.6748047,0.5908203-3.4970703-0.5170898c-0.8232422-1.1083984-0.5917969-2.6743164,0.5166016-3.4975586
						c2.234375-1.6591797,5.5507812-2.5053711,9.1318359-2.3164062c3.5683594,0.1875,6.7900391,1.375,8.8388672,3.2578125
						c1.0166016,0.934082,1.0839844,2.515625,0.1494141,3.5322266
						C193.0048676,204.6294098,192.332016,204.9013824,191.6562347,204.9013824z" />
					<path d="M236.869278,204.9013824c0.6044922,0,1.2099609-0.2177734,1.6904297-0.6591797
						c0.9189453-0.84375,2.9033203-1.7983398,5.7177734-1.9462891c2.8125-0.1425781,4.8876953,0.5942383,5.8896484,1.3378906
						c1.1103516,0.8237305,2.6748047,0.5908203,3.4970703-0.5170898c0.8232422-1.1083984,0.5917969-2.6743164-0.5166016-3.4975586
						c-2.234375-1.6591797-5.5507812-2.5053711-9.1318359-2.3164062c-3.5683594,0.1875-6.7900391,1.375-8.8388672,3.2578125
						c-1.0166016,0.934082-1.0839844,2.515625-0.1494141,3.5322266
						C235.5206451,204.6294098,236.1934967,204.9013824,236.869278,204.9013824z" />
				</g>
				<g className="fill--eyes eyes--is-being-pet--hates">
					<path d="M191.9220123,199.0496063c0,4.7001038-3.4291687,8.5102844-7.659256,8.5102844
						c-4.2301025,0-7.6592712-3.8101807-7.6592712-8.5102844c0-3.0506439,3.4291687-3.0506439,7.6592712-3.0506439
						C188.4928436,195.9989624,191.9220123,195.9989624,191.9220123,199.0496063z" />
					<path d="M251.9220123,199.0496063c0,4.7001038-3.4291687,8.5102844-7.659256,8.5102844
						c-4.2301025,0-7.6592712-3.8101807-7.6592712-8.5102844c0-3.0506439,3.4291687-3.0506439,7.6592712-3.0506439
						C248.4928436,195.9989624,251.9220123,195.9989624,251.9220123,199.0496063z" />
				</g>
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Bear/Eyes.js